import {
  CLIENTS_CLEAR_DATA,
  CLIENTS_GET_REQUEST,
  CLIENTS_GET_REQUEST_FAILED,
  CLIENTS_GET_REQUEST_SUCCESS,
  CLIENT_ADD_REQUEST,
  CLIENT_ADD_REQUEST_FAILED,
  CLIENT_ADD_REQUEST_SUCCESS,
  CLIENT_EDIT_REQUEST,
  CLIENT_EDIT_REQUEST_FAILED,
  CLIENT_EDIT_REQUEST_SUCCESS,
  CLIENT_REMOVE_REQUEST,
  CLIENT_REMOVE_REQUEST_FAILED,
  CLIENT_REMOVE_REQUEST_SUCCESS,
  CLIENT_UPGRADE_REQUEST,
  CLIENT_UPGRADE_REQUEST_SUCCESS,
  CLIENT_UPGRADE_REQUEST_FAILED,
  VERTICALS_GET_REQUEST,
  VERTICALS_GET_REQUEST_FAILED,
  VERTICALS_GET_REQUEST_SUCCESS,
  CLIENT_SEARCH_REQUEST,
  CLIENT_SEARCH_REQUEST_FAILED,
  CLIENT_SEARCH_REQUEST_SUCCESS
} from "../constants";

const initialState = {
  data: [],
  verticals: [],
  added: {},
  removed: {},
  edited: {},
  search: [],
  searchString: "",
  isLoading: false,
  error: {}
};

export default (state = initialState, action) => {
  switch (action.type) {
    case CLIENTS_CLEAR_DATA:
      return {
        ...state,
        data: []
      };

    case CLIENTS_GET_REQUEST:
    case CLIENT_UPGRADE_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case CLIENT_ADD_REQUEST:
      return {
        ...state,
        added: action.payload,
        isLoading: true
      };
    case CLIENT_EDIT_REQUEST:
      return {
        ...state,
        edited: action.payload,
        isLoading: true
      };
    case CLIENT_REMOVE_REQUEST:
      return {
        ...state,
        removed: action.payload,
        isLoading: true
      };
    case VERTICALS_GET_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case CLIENT_SEARCH_REQUEST:
      return {
        ...state,
        searchString: action.payload,
        isLoading: true
      };
    case CLIENTS_GET_REQUEST_SUCCESS:
      return {
        ...state,
        data: [...action.payload],
        isLoading: false,
        error: {}
      };
    case CLIENT_ADD_REQUEST_SUCCESS:
      return {
        ...state,
        data: [...state.data, action.payload],
        added: {},
        isLoading: false,
        error: {}
      };
    case CLIENT_EDIT_REQUEST_SUCCESS:
      return {
        ...state,
        data: [
          ...state.data.filter(({ id }) => id !== action.payload.id),
          action.payload
        ],
        edited: {},
        isLoading: false,
        error: {}
      };
    case CLIENT_REMOVE_REQUEST_SUCCESS:
      return {
        ...state,
        data: [...state.data.filter(({ id }) => id !== action.payload)],
        removed: {},
        isLoading: false,
        error: {}
      };
    case CLIENT_UPGRADE_REQUEST_SUCCESS:
      return {
        ...state,
        data: state.data.map(client =>
          client.id === action.payload.id ? action.payload : client
        ),
        isLoading: false,
        error: {}
      };
    case VERTICALS_GET_REQUEST_SUCCESS:
      return {
        ...state,
        verticals: [...action.payload],
        isLoading: false,
        error: {}
      };
    case CLIENT_SEARCH_REQUEST_SUCCESS:
      return {
        ...state,
        search: [...action.payload],
        isLoading: false,
        error: {}
      };
    case CLIENT_SEARCH_REQUEST_FAILED:
    case CLIENTS_GET_REQUEST_FAILED:
    case CLIENT_ADD_REQUEST_FAILED:
    case CLIENT_EDIT_REQUEST_FAILED:
    case CLIENT_REMOVE_REQUEST_FAILED:
    case CLIENT_UPGRADE_REQUEST_FAILED:
    case VERTICALS_GET_REQUEST_FAILED:
      return {
        ...state,
        isLoading: false,
        error: action.payload
      };
    default:
      return state;
  }
};
